import { DashboardLayout } from './layouts/dashboard/DashboardLayout';
import { AccessDeniedPage } from './pages/errors/AccessDeniedPage';
import { NotFoundPage } from './pages/errors/NotFoundPage';
import { useHasHydrated, useIsAuthenticated } from './stores';

export function NotFoundRouteComponent() {
  const isHydrated = useHasHydrated();
  const isAuthenticated = useIsAuthenticated();

  if (!isHydrated) {
    return <NotFoundPage />;
  }
  if (isAuthenticated) {
    return (
      <DashboardLayout>
        <NotFoundPage />
      </DashboardLayout>
    );
  }
  return <NotFoundPage />;
}

export function UnauthorizedRouteComponent() {
  const isHydrated = useHasHydrated();
  const isAuthenticated = useIsAuthenticated();

  if (!isHydrated) {
    return <AccessDeniedPage />;
  }
  if (isAuthenticated) {
    return (
      <DashboardLayout>
        <AccessDeniedPage />
      </DashboardLayout>
    );
  }
  return <AccessDeniedPage />;
}
